export default __webpack_public_path__ + "cd9bce7bc363d9c9ab85568f16b04814.png";